import {
  Award, BadgeCheck, BarChart3, Briefcase, CalendarCheck, CheckCircle2, Clock, Coins, FileCheck, FileDown, Flag, Flame, Gem, Hourglass, Inbox, Landmark,
  PartyPopper, PieChart, PiggyBank, Plug, Receipt, Scale, Shield, ShieldCheck, Tags, Target, TrendingUp, Trophy, Wand2, type LucideIcon,
} from 'lucide-react';

/** Lucide names used by core `ACHIEVEMENTS` (and a few extras). Explicit map keeps the icon bundle small. */
const ICONS: Record<string, LucideIcon> = {
  award: Award, 'badge-check': BadgeCheck, 'calendar-check': CalendarCheck, 'check-circle': CheckCircle2, clock: Clock, coins: Coins,
  'file-down': FileDown, flag: Flag, flame: Flame, gem: Gem, hourglass: Hourglass, inbox: Inbox, landmark: Landmark,
  'party-popper': PartyPopper, 'pie-chart': PieChart, 'piggy-bank': PiggyBank, scale: Scale, shield: Shield, 'shield-check': ShieldCheck,
  tags: Tags, target: Target, 'trending-up': TrendingUp, trophy: Trophy,
  'bar-chart': BarChart3, briefcase: Briefcase, 'file-check': FileCheck, plug: Plug, receipt: Receipt, wand: Wand2,
};

/** Maps an achievement's `icon` name (lucide kebab-case) to a component; falls back to Award. */
export const achievementIcon = (name: string | undefined): LucideIcon => (name ? ICONS[name] : undefined) ?? Award;
